// Тот же чат поддержки, который уже используется в кабинете. Обычная ссылка открывается по явному нажатию пользователя.
export const SUPPORT_TELEGRAM_URL = "https://t.me/+qBktsh-Hw1lmN2My";

// Совместимость с кнопкой поддержки в окне технических работ.
export function openSupportTelegram() {
  window.open(SUPPORT_TELEGRAM_URL, "_blank", "noopener,noreferrer");
}
